import { useState, useMemo } from "react";
import { IconX } from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import NoDataFound from "../../../components/common/NoDataFound";
import { useLanguage } from "../../../context/LanguageContext";

type CityItem = string; // or interface if you have more properties

type ViewCitiesModalProps = {
  open: boolean;
  onClose: () => void;
  citiesItem?: CityItem[];
};

const ViewCitiesModal = ({
  open,
  onClose,
  citiesItem = [],
}: ViewCitiesModalProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  const { t, language } = useLanguage();

  const getCityDisplayName = (cityStr: string) => {
    if (!cityStr) return "";
    if (cityStr.includes("::")) {
      const parts = cityStr.split("::");
      return (language === "ar" && parts[1]) ? parts[1] : parts[0];
    }
    return cityStr;
  };

  const filteredCities = useMemo(() => {
    return citiesItem.filter((city) => {
      if (!city) return false;
      const lowercaseSearch = searchTerm.toLowerCase();
      if (city.includes("::")) {
        const parts = city.split("::");
        return parts[0].toLowerCase().includes(lowercaseSearch) || parts[1].toLowerCase().includes(lowercaseSearch);
      }
      return city.toLowerCase().includes(lowercaseSearch);
    });
  }, [citiesItem, searchTerm]);

  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div className="bg-[#F7F6F2] rounded-3xl w-[500px] max-h-[76vh] flex flex-col  overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between px-4 py-3 border-b">
            <h2 className="text-lg font-medium text-[#212121]">
              {t("View Cities")} ({filteredCities.length})
            </h2>
            <button
              onClick={onClose}
              className="p-2 rounded-full border border-[#D2D2D2]"
            >
              <IconX size={20} />
            </button>
          </div>

          {/* Search + Filter */}
          <div className="px-4 py-3">
            <NormalSearch
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {/* Drivers List */}
          <div className="flex-1 overflow-y-auto hide-scrollbar px-4 pb-4 space-y-1">
            {filteredCities.length > 0 ? (
              filteredCities.map((city, index) => (
                <div
                  key={`${city}-${index}`}
                  className={`flex items-center py-1 ${
                    filteredCities.length > 999 ? "gap-2" : "gap-2"
                  }`}
                >
                  <span className="h-8 w-8 flex justify-center items-center text-[#212121]/70 rounded-full border border-[#D2D2D2]">
                    {index + 1}
                  </span>
                  <p className="text-[#000000] text-base font-normal">{getCityDisplayName(city)}</p>
                </div>
              ))
            ) : (
              <NoDataFound title="No Data Found" message="" />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewCitiesModal;
